// src/screens/seller/reporting/Reporting.js
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FiTrendingUp, FiPercent, FiTag } from "react-icons/fi";
import { useTheme } from "../../../contexts/ThemeContext";
import SellerMasterLayout from "../../../layouts/seller/SellerMasterLayout";
import AppContext from "../../../contexts/AppContext";
import StackedBarChart from "../../../components/general/barchart/BarChart";
import "../../../assets/css/seller/screens/SellerReporting.css";


const ReportingManagement = () => {
  const { isDark } = useTheme();
  const { baseUrl ,sellerAuthToken } = useContext(AppContext);

  const [statsData, setStatsData] = useState(null);

  const getStats = () => {
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const fd = new FormData();
    fd.append("seller_id", seller?.id);

    axios
      .post(`${baseUrl}/seller/order/stats`, fd,{
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },)
      .then((res) => {
        setStatsData(res.data);
      })
      .catch((err) => {
        console.log("REPORTING API ERROR:", err.response?.data || err.message);
      });
  };

  useEffect(() => {
    getStats();
  }, []);

  const formatNumber = (num) => {
    if (!num) return "0";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num;
  };

  const weeklyData = statsData?.weekly_data ?? [];
  const chartLabels = weeklyData.map((d) => d.day);
  const chartValues = weeklyData.map((d) => d.orders);

  return (
    <SellerMasterLayout>
      <div className={`rp-shell-wrap ${isDark ? "dark-mode" : ""}`}>
        <main className="rp-main">
          <section className="rp-card-shell">

            {/* ── Stat Cards ── */}
            <div className="rp-overview">

              <div className="rp-overview-card">
                <div>
                  <span className="rp-overview-label">Sales Overview</span>
                  <h3 className="rp-overview-value">
                    {formatNumber(statsData?.orders_last_30_days)}
                  </h3>
                  <p className="rp-overview-sub">Orders in the last 30 days</p>
                </div>
                <div className="rp-overview-icon"><FiTrendingUp /></div>
              </div>

              <div className="rp-overview-card">
                <div>
                  <span className="rp-overview-label">Conversion Rate</span>
                  <h3 className="rp-overview-value">
                    {statsData?.conversion_rate ?? 0}%
                  </h3>
                  <p className="rp-overview-sub">Completed vs total orders</p>
                </div>
                <div className="rp-overview-icon"><FiPercent /></div>
              </div>

              <div className="rp-overview-card">
                <div>
                  <span className="rp-overview-label">Top Category</span>
                  <h3 className="rp-overview-value">
                    {statsData?.top_category ?? "—"}
                  </h3>
                  <p className="rp-overview-sub">
                    {statsData?.top_category_pct ?? 0}% of total sales
                  </p>
                </div>
                <div className="rp-overview-icon"><FiTag /></div>
              </div>

            </div>

            {/* ── Traffic & Sales Chart ── */}
            <div className="rp-chart-card">
              <h4 className="rp-chart-title">Traffic & Sales</h4>
              <StackedBarChart
                labels={chartLabels}
                datasets={[{ label: "Orders", data: chartValues, color: "#eb6834" }]}
                isDark={isDark}
              />
            </div>

          </section>
        </main>
      </div>
    </SellerMasterLayout>
  );
};

export default ReportingManagement;